const h = {
  name: "Headquarters",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,4V0h-2v4h-3v2h-4v4h-2v4H6v12H2v12H0v2h2v0h36v0h2v-2h-2V26h-4V14h-4v-4h-2V6h-4V4H21z M24,8h2v2h-2V8z
			 M24,12h4v2h-4V12z M24,16h8v2h-8V16z M24,20h8v2h-8V20z M24,24h8v2h-8V24z M24,28h12v2H24V28z M24,32h12v2H24V32z M24,36h12v2H24
			V36z M16,36v2H4v-2H16z M18,38V6h4v32H18z M16,34H4v-2h12V34z M16,30H4v-2h12V30z M16,26H8v-2h8V26z M16,22H8v-2h8V22z M16,18H8
			v-2h8V18z M16,14h-4v-2h4V14z M16,10h-2V8h2V10z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Headquarters
};
